import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import './Layout.css';

export default function Layout({ children, title }) {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="layout">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="layout-main">
        <div className="layout-mobilebar">
          <button className="layout-menu-btn" aria-label="Menü öffnen" aria-expanded={navOpen} onClick={() => setNavOpen(true)}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="4" y1="7" x2="20" y2="7" />
              <line x1="4" y1="12" x2="20" y2="12" />
              <line x1="4" y1="17" x2="20" y2="17" />
            </svg>
          </button>
          <img src="/images/logo.svg" alt="Logo" className="layout-mobile-logo" />
        </div>
        {title && (
          <div className="layout-topbar">
            <h1 className="layout-page-title">{title}</h1>
          </div>
        )}
        <div className="layout-content">{children}</div>
      </main>
    </div>
  );
}
